export default __webpack_public_path__ + "static/media/gwar.137b7ea3.jpeg";